import { action, createRequestTypes } from '@/utils/actions.utils'
import { i18nService } from '@/services'

export const SET_LOCALE = 'SET_LOCALE'
const setLocale = (data) => {
	return { type: SET_LOCALE, payload: data }
}

export const FETCH_LANGUAGES = createRequestTypes('FETCH_LANGUAGES')
const fetchLanguages = ({ lang }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await i18nService.fetchLanguages({ lang })
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(FETCH_LANGUAGES.REQUEST)
	}
	function success(payload) {
		return action(FETCH_LANGUAGES.SUCCESS, payload)
	}
	function failure(err) {
		return action(FETCH_LANGUAGES.FAILURE, null, err, false)
	}
}

export default {
	fetchLanguages,
	setLocale
}
